<template>
    <div>
        <h4>Nouvelle personne physique</h4>
        <b-card>
            <div class="row mt-0">
                <b-col sm="12" class="mt-0">
                    <label>Identité</label>
                </b-col>

                <b-col sm="3" class="pr-1">
                    <b-form-select
                        v-model="form.civility_option_id"
                        :options="civilityOptions"
                        size="sm"
                        :state="!$v.form.civility_option_id.$invalid"
                    />
                </b-col>
                <b-col sm="4" class="pl-1 pr-1">
                    <b-input
                        v-model="form.firstname"
                        size="sm"
                        placeholder="Prénom"
                        :state="!$v.form.firstname.$invalid"
                    />
                </b-col>
                <b-col sm="5" class="pl-1">
                    <b-input
                        v-model="form.surname"
                        size="sm"
                        placeholder="Nom"
                        :state="!$v.form.surname.$invalid"
                    />
                </b-col>

                <b-col sm="9" class="mt-3">
                    <label>Naissance</label>
                </b-col>
                <b-col sm="3" class="mt-3">
                    <label>Nationalité</label>
                </b-col>

                <b-col sm="3" class="pr-1">
                    <b-input
                        v-model="form.date_of_birth"
                        size="sm"
                        placeholder="Date de naissance"
                        :formatter="dateFormatter"
                        :state="!$v.form.date_of_birth.$invalid"
                    />
                </b-col>
                <b-col sm="6" class="pl-1 pr-1">
                    <b-input
                        v-model="form.place_of_birth"
                        size="sm"
                        placeholder="Ville de naissance"
                        :state="!$v.form.place_of_birth.$invalid"
                    />
                </b-col>
                <b-col sm="3" class="pl-1">
                    <b-form-select
                        v-model="form.nationality_option_id"
                        :options="nationalityOptions"
                        size="sm"
                    />
                </b-col>

                <b-col sm="12" class="mt-3">
                    <label>Adresse</label>
                </b-col>

                <b-col sm="12">
                    <b-input
                        v-model="form.adress_1"
                        size="sm"
                        class="mb-1"
                        :state="!$v.form.adress_1.$invalid"
                    />
                </b-col>

                <b-col sm="12">
                    <b-input v-model="form.adress_2" size="sm" class="mb-1" />
                </b-col>

                <b-col sm="2" class="pr-1">
                    <b-input
                        v-model="form.zip_code"
                        size="sm"
                        class="mb-1"
                        placeholder="Code postal"
                        :state="!$v.form.zip_code.$invalid"
                    />
                </b-col>
                <b-col sm="7" class="pl-1 pr-1">
                    <b-input
                        v-model="form.city"
                        size="sm"
                        class="mb-1"
                        placeholder="Ville"
                        :state="!$v.form.city.$invalid"
                    />
                </b-col>
                <b-col sm="3" class="pl-1">
                    <b-form-select
                        v-model="form.country_option_id"
                        :options="countryOptions"
                        size="sm"
                    />
                </b-col>
            </div>
            <div class="mt-3">
                <b-button
                    variant="success"
                    size="sm"
                    :disabled="submitIsDisabled"
                    @click="storePhysicalPerson"
                >
                    <i class="fas fa-save fa-fw"></i> Enregistrer
                </b-button>

                <b-button variant="secondary" size="sm" @click="resetStatus">
                    <i class="fas fa-times fa-fw"></i> Annuler
                </b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Formatter from '../../../../common/mixins/Formatter'

function mustBeDate(value) {
    const day = value.substring(0, 2)
    const month = value.substring(3, 5)
    const year = value.substring(6, 10)
    const dateToCheck = this.$moment(`${year}-${month}-${day}`)
    return dateToCheck.isValid() && parseInt(year) > 1900 // && parseInt(year) <= new Date().getFullYear() - 18
}

export default {
    name: 'PhysicalPersonCreate',

    mixins: [Formatter],

    props: {
        personType: null,
    },

    data() {
        return {
            form: {},
            civilityOptions: [
                { value: null, text: 'Civilité' },
                { value: '1', text: 'Monsieur' },
                { value: '2', text: 'Madame' },
            ],
        }
    },

    validations: {
        form: {
            civility_option_id: {
                required,
            },
            firstname: {
                required,
            },
            surname: {
                required,
            },
            date_of_birth: {
                required,
                // mustBeDate
            },
            place_of_birth: {
                required,
            },
            adress_1: {
                required,
            },
            city: {
                required,
            },
            zip_code: {
                required,
            },
        },
    },

    created() {
        this.initForm()
    },

    methods: {
        initForm() {
            this.form.civility_option_id = null
            this.form.nationality_option_id = this.french.value
            this.form.country_option_id = this.french.value
        },

        async storePhysicalPerson() {
            this.form.client_id = this.client.id
            try {
                const response = await axios.post(
                    `/${this.personType}/physicalPersons/new`,
                    this.form
                )
                this.$store.commit('legalVM/SET_CLIENT', response.data.data)
                this.$store.commit('legalVM/RESET_STATUS')
            } catch (error) {
                // handle error
                console.log(error)
            }
        },

        resetStatus() {
            this.$store.commit('legalVM/RESET_STATUS')
        },
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
            nationalityOptions: (state) => state.data.options.nationalities,
            countryOptions: (state) => state.data.options.countries,
        }),

        french() {
            return this.nationalityOptions.find((item) => item.alpha3 === 'FRA')
        },

        submitIsDisabled() {
            return this.$v.$invalid
        },
    },
}
</script>

<style scoped></style>
